import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const GalleryUploadMedia = () => {
    // context
    const { galleryMedia, setGalleryMedia, galleryMediaId, setGalleryMediaId } =
        useContext(context);
    // useEffect
    useEffect(() => {
        const ids = [];
        const files = [];
        galleryMedia.map((file) => {
            ids.push(file._id);
            files.push({
                uid: file._id,
                name: `${file.type}/${file._id}`,
                status: "done",
                url: file.address,
            });
        });
        setGalleryMediaId(ids);
        setGalleryMedia(files);
    }, []);
    // upload
    const onChange = (info) => {
        setGalleryMedia(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setGalleryMediaId([...galleryMediaId, file._id]);
                return null;
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = galleryMedia.filter((file) => file !== info);
        const newIds = galleryMediaId.filter((id) => id !== info.uid);
        setGalleryMediaId(newIds);
        setGalleryMedia(newFiles);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
            }}
        >
            <ImgCrop rotationSlider>
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65eadb29a3b46a402ebc7a05`}
                    listType="picture-card"
                    fileList={galleryMedia}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {galleryMedia.length < 10 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65eadb29a3b46a402ebc7a05`}
                listType="picture-card"
                fileList={galleryMedia}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {galleryMedia.length < 10 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {galleryMedia.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default GalleryUploadMedia;
